import { useTranslation } from 'react-i18next'

import { QA_SECTION_KEY } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import Text from '../../Text'

import { QA_NAME_SETTINGS_SECTION } from './SettingsSection.constants'

import * as styles from './SettingsSection.module.css'

function SettingsSection({
  Buttons,
  buttonsProps,
  children,
  className = styles.SettingsSection,
  descriptionKey,
  qaName,
  titleKey,
}) {
  const { t } = useTranslation()

  const qaProps = getQaSelector(
    { def: QA_NAME_SETTINGS_SECTION, value: qaName },
    QA_SECTION_KEY
  )

  return (
    <section {...qaProps} className={className}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          {titleKey ? (
            <Text Element='h3' className={styles.title}>
              {t(titleKey)}
            </Text>
          ) : null}
          {Buttons ? <Buttons {...buttonsProps} /> : null}
        </div>
        {descriptionKey ? (
          <Text Element='p' className={styles.description}>
            {t(descriptionKey)}
          </Text>
        ) : null}
      </div>
      {children}
    </section>
  )
}

export default SettingsSection
